/* eslint-disable */
import Vue from "vue";

import Router from "vue-router";
import Home from "@/views/Home";
import Cases from "@/views/Cases";
import Concordance from "@/views/Concordance";
import About from "@/views/About";
import FrequencyLists from "@/views/FrequencyLists";
import Documents from "@/views/Documents";
import WordProfiles from "@/views/WordProfiles";
import Samples from "@/views/Samples";
import TimeSeries from "@/views/TimeSeries";
import Statistics from "@/views/Statistics";
import Similarity from "@/views/Similarity";
import Graph from "@/views/Graph";
import NamesMap from "@/views/NamesMap";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      props: true,
    },
    {
      path: "/cases",
      name: "Cases",
      component: Cases,
      props: true,
    },
    {
      path: "/concordance/",
      name: "Concordance",
      component: Concordance,
      props: true,
    },
    {
      path: "/concordance/:concordanceWord",
      name: "ConcordanceTrigger",
      component: Concordance,
      props: true,
    },
    {
      path: "/concordance/:concordanceWord/:publicationYear",
      name: "ConcordanceTime",
      component: Concordance,
      props: true,
    },
    {
      path: "/about",
      name: "About",
      component: About,
      props: true,
    },
    {
      path: "/frequency_lists",
      name: "FrequencyLists",
      component: FrequencyLists,
      props: true,
    },
    {
      path: "/maps",
      name: "NamesMap",
      component: NamesMap,
      props: true,
    },
    {
      path: "/word_profiles",
      name: "WordProfiles",
      component: WordProfiles,
      props: true,
    },
    {
      path: "/samples",
      name: "Samples",
      component: Samples,
      props: true,
    },
    {
      path: "/time_series",
      name: "TimeSeries",
      component: TimeSeries,
      props: true,
    },
    {
      path: "/statistics",
      name: "Statistics",
      component: Statistics,
      props: true,
    },
    {
      path: "/similarity",
      name: "Similarity",
      component: Similarity,
      props: true,
    },
    {
      path: "/graph",
      name: "Graph",
      component: Graph,
      props: true,
    },
    { path: "*", redirect: "/" },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js